module.exports = {"540124100":"曲水镇","540124101":"达嘎镇","540124201":"才纳乡","540124202":"南木乡","540124203":"聂当乡","540124204":"茶巴拉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540124.json
// module id = 2815
// module chunks = 0